import { motion } from "framer-motion";
import { ArrowUpRight, ArrowDown } from "lucide-react";
import { HERO, SERVICES } from "@/lib/content";
import { scrollToId } from "@/lib/site";
import { Kinetic } from "@/components/Kinetic";
import HeroVideo from "@/components/HeroVideo";

const fade = (d) => ({
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay: d, ease: [0.22, 1, 0.36, 1] },
});

const Marquee = () => {
  const items = [...SERVICES, ...SERVICES];
  return (
    <div className="relative mt-20 overflow-hidden border-y border-white/10 py-5 lg:mt-28" aria-hidden="true">
      <div className="marquee-track flex animate-marquee items-center gap-10 whitespace-nowrap">
        {items.map((s, i) => (
          <span key={i} className="flex items-center gap-10 font-display text-xl font-bold uppercase tracking-tight text-white/70 sm:text-2xl">
            {s.title}
            <span className="h-2 w-2 rounded-full bg-emerald-dot" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default function Hero() {
  return (
    <section id="home" data-testid="hero-section" className="relative overflow-hidden bg-ink pt-[120px] text-white lg:pt-[150px]">
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 bottom-10 h-[420px] w-[420px] rounded-full bg-ink-2" />
      <div aria-hidden="true" className="pointer-events-none absolute right-[8%] top-[90px] h-40 w-40 rounded-full border-[14px] border-white/[0.04]" />
      <div className="wrap relative grid grid-cols-1 items-center gap-14 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-5">
          <Kinetic
            as="h1"
            animateOnMount
            text={HERO.headline}
            hl={[3]}
            testId="hero-headline"
            className="display text-4xl leading-[0.95] text-white sm:text-5xl lg:text-6xl"
          />
          <motion.p {...fade(0.45)} data-testid="hero-supporting" className="mt-7 max-w-[30rem] text-base leading-relaxed text-white/70 sm:text-lg">
            {HERO.supporting}
          </motion.p>
          <motion.div {...fade(0.6)} className="mt-9 flex flex-wrap gap-3">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToId("contact"); }}
              data-testid="hero-cta-start-project"
              className="btn-primary"
            >
              START A PROJECT <ArrowUpRight className="btn-arrow h-4 w-4" />
            </a>
            <a
              href="#services"
              onClick={(e) => { e.preventDefault(); scrollToId("services"); }}
              data-testid="hero-cta-explore-services"
              className="btn-ghost-dark"
            >
              EXPLORE SERVICES <ArrowDown className="h-4 w-4" />
            </a>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <HeroVideo />
        </motion.div>
      </div>
      <Marquee />
    </section>
  );
}
